import { MAX_SIZE_OF_ALL_ATTACHMENTS, MAX_ATTACHMENTS } from '@/config';
import persons from '@/mixins/persons';
import distributionChannels from '@/mixins/distributionChannels';

export default {
  mixins: [persons, distributionChannels],
  computed: {
    attachments() { return this.$store.getters.getAttachments; },
    /*
    * Computed returns true if total size of all attachments is higher
    * than MAX_SIZE_OF_ALL_ATTACHMENTS
    * */
    allAttachmentsSizeError() {
      const totalSizeOfAllAttachments = this.attachments
        .map((attachment) => attachment.file.size)
        .reduce((acc, size) => acc + size, 0);
      return MAX_SIZE_OF_ALL_ATTACHMENTS < totalSizeOfAllAttachments;
    },
    /*
    * Computed returns true if we have uploaded more attachment than is allowed
    * */
    exceededMaxLimitOfAttachments() { return this.attachments.length > MAX_ATTACHMENTS; },
    /*
    * Computed returns true if at least one of the attachment has not valid format or size
    * */
    atLeastOneOfAttachmentsIsNotValid() {
      return this.attachments.some((att) => att.maxSizeError || att.formatError || att.minSizeError);
    },
    /*
    * Methods returns array of error codes with all attachments errors.
    * */
    attachmentsErrors() {
      if (this.model.step < 19) return [];

      const errors = [];

      if (this.atLeastOneOfAttachmentsIsNotValid) errors.push('AT_LEAST_ONE_OF_ATTACHMENTS_IS_NOT_VALID');

      const validAttachments = this.attachments.filter((attachment) => !attachment.maxSizeError && !attachment.minSizeError && !attachment.formatError);

      if (!this.model.broker.callcentrumBroker) {
        if (this.allAttachmentsSizeError) errors.push('ATTACHMENTS_SIZE');
        if (this.exceededMaxLimitOfAttachments) errors.push('EXCEEDED_MAX_LIMIT');

        this.personsWithRequiredAttachments.forEach((person) => {
          const { personIndex, requiredAttachments } = person;
          const personValidAttachments = validAttachments.filter((att) => att.personIndex === personIndex);

          requiredAttachments.forEach((requiredAtt) => {
            const { name$ } = requiredAtt;
            if (personValidAttachments.every((validAtt) => validAtt.type !== name$)) errors.push(`${name$}-${personIndex}`);
          });
        });
      }

      this.personsWithRequiredAttachmentsForCourier.forEach((person) => {
        const { personIndex, requiredAttachments } = person;
        const personValidAttachments = validAttachments.filter((att) => att.personIndex === personIndex);

        requiredAttachments.forEach((requiredAtt) => {
          const { name$ } = requiredAtt;
          if (personValidAttachments.every((validAtt) => validAtt.type !== name$)) errors.push(`${name$}-${personIndex}`);
        });
      });

      return errors;
    },
  },
};
